export enum Languages {
	English = 'English',
	Spanish = 'Spanish',
	French = 'French'
}

export enum Locales {
	en = 'en',
	fr = 'fr',
	es = 'es'
}

export const LOCALES = {
	[Languages.English]: Locales.en,
	[Languages.French]: Locales.fr,
	[Languages.Spanish]: Locales.es
}

export const DEFAULT_LANGUAGE = Languages.English
export const DEFAULT_LOCALE = LOCALES[DEFAULT_LANGUAGE]
